import sshcp from '@/api/sshcp';

export default {
  namespaced: true,
  state: {
    regionsMapping: [],
    regions: [],
    districtsMapping: [],
    districts: [],
    districtByRegion: [],
    groups: [],
    vendors: [],
    masterActivities: [],
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total_page: 1
    },
    totalData: 0,
    po_numbers: [],
    budgetsMapping: [],
    userSSHCP: [],
    userMapping: [],
    approvalMapping: [],
    activities: [],
    formRequests: [],
    formRequest: null,
    progressTracking: [],
    usersByGroup: [],
    filter: {
      start_year: '',
      start_created_date: '',
      end_created_date: '',
      start_date_submitted: '',
      end_date_submitted: '',
      start_date_fully_approved: '',
      end_date_fully_approved: '',
      house_id: null,
      region: null,
      district: null,
      type_of_activity: null,
      status: null,
      isSubmit: false,
      isDownload: false
    },
    dashboard: {},
    budgetChart: {}
  },
  mutations: {
    set(state, payload) {
      Object.keys(payload).forEach(key => {
        if (state.hasOwnProperty(key)) {
          state[key] = payload[key];
        }
      });
    }
  },
  actions: {
    // Master Data Region
    async getRegions({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getRegions(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            regions: result,
            pagination,
            totalData
          });
        } else {
          const regions = data.data;
          commit('set', {
            regions,
            totalData: regions.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getRegionsMapping({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getRegionsMapping(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            regionsMapping: result,
            pagination,
            totalData
          });
        } else {
          const regionsMapping = data.data;
          commit('set', {
            regionsMapping,
            totalData: regionsMapping.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async createRegionMapping(ctx, payload) {
      try {
        const { data } = await sshcp.createRegionMapping(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async updateRegionMapping(ctx, { id, data: payload }) {
      try {
        const { data } = await sshcp.updateRegionMapping(id, payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },

    // Master Data District
    async getDistricts({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getDistricts(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            districts: result,
            pagination,
            totalData
          });
        } else {
          const districts = data.data;
          commit('set', {
            districts,
            totalData: districts.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getDistrictsMapping({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getDistrictsMapping(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            districtsMapping: result,
            pagination,
            totalData
          });
        } else {
          const districtsMapping = data.data;
          commit('set', {
            districtsMapping,
            totalData: districtsMapping.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getDistrictByRegion({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getDistrictByRegion(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            districtByRegion: result,
            pagination,
            totalData
          });
        } else {
          const districtByRegion = data.data;
          commit('set', {
            districtByRegion,
            totalData: districtByRegion.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async createDistrictMapping(ctx, payload) {
      try {
        const { data } = await sshcp.createDistrictMapping(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async updateDistrictMapping(ctx, { id, data: payload }) {
      try {
        const { data } = await sshcp.updateDistrictMapping(id, payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },

    // Master Data Group
    async getGroup({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getGroup(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            groups: result,
            pagination,
            totalData
          });
        } else {
          const groups = data.data;
          commit('set', {
            groups,
            totalData: groups.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async createGroup(ctx, payload) {
      try {
        const { data } = await sshcp.createGroup(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async updateGroup(ctx, { id, data: payload }) {
      try {
        const { data } = await sshcp.updateGroup(id, payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },

    // Master Data Vendor
    async getVendor({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getVendor(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            vendors: result,
            pagination,
            totalData
          });
        } else {
          const vendors = data.data;
          commit('set', {
            vendors,
            totalData: vendors.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async createVendor(ctx, payload) {
      try {
        const { data } = await sshcp.createVendor(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async updateVendor(ctx, { id, data: payload }) {
      try {
        const { data } = await sshcp.updateVendor(id, payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },

    // Master Data Activities
    async getMasterActivities({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getMasterActivities(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            masterActivities: result,
            pagination,
            totalData
          });
        } else {
          const masterActivities = data.data;
          commit('set', {
            masterActivities,
            totalData: masterActivities.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async createActivities(ctx, payload) {
      try {
        const { data } = await sshcp.createActivities(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async updateActivities(ctx, { id, data: payload }) {
      try {
        const { data } = await sshcp.updateActivities(id, payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },

    // Budget Mapping
    async getPONumber({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getPONumber(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            po_numbers: result,
            pagination,
            totalData
          });
        } else {
          const po_numbers = data.data;
          commit('set', {
            po_numbers,
            totalData: po_numbers.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getBudgetMapping({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getBudgetMapping(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            budgetsMapping: result,
            pagination,
            totalData
          });
        } else {
          const budgetsMapping = data.data;
          commit('set', {
            budgetsMapping,
            totalData: budgetsMapping.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getAmountPO(ctx, { poNumber }) {
      try {
        const { data } = await sshcp.getAmountPO(poNumber);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async createBudgetMapping(ctx, payload) {
      try {
        const { data } = await sshcp.createBudgetMapping(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async updateBudgetMapping(ctx, { id, data: payload }) {
      try {
        const { data } = await sshcp.updateBudgetMapping(id, payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },

    // User Mapping
    async getUserMapping({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getUserMapping(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            userMapping: result,
            pagination,
            totalData
          });
        } else {
          const userMapping = data.data;
          commit('set', {
            userMapping,
            totalData: userMapping.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getUserSSHCP({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getUserSSHCP(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            userSSHCP: result,
            pagination,
            totalData
          });
        } else {
          const userSSHCP = data.data;
          commit('set', {
            userSSHCP,
            totalData: userSSHCP.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getDetailUserMapping(ctx, { id }) {
      try {
        const { data } = await sshcp.getDetailUserMapping(id);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async createUserMapping(ctx, payload) {
      try {
        const { data } = await sshcp.createUserMapping(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async updateUserMapping(ctx, { id, data: payload }) {
      try {
        const { data } = await sshcp.updateUserMapping(id, payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async importUser({ commit }, payload) {
      try {
        const { data } = await sshcp.importUser(payload);
        const importUser = data.data;
        commit('set', {
          importUser
        });
        return data;
      } catch (err) {
        return err.response.data;
      }
    },

    // Approval Mapping
    async getApprovalMapping({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getApprovalMapping(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            approvalMapping: result,
            pagination,
            totalData
          });
        } else {
          const approvalMapping = data.data;
          commit('set', {
            approvalMapping,
            totalData: approvalMapping.length
          });
        }
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getUserByGroup({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getUserByGroup(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            usersByGroup: result,
            pagination,
            totalData
          });
        } else {
          const usersByGroup = data.data;
          commit('set', {
            usersByGroup,
            totalData: usersByGroup.length
          });
        }
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getDetailApprovalMapping(ctx, { id }) {
      try {
        const { data } = await sshcp.getDetailApprovalMapping(id);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async createApprovalMapping(ctx, payload) {
      try {
        const { data } = await sshcp.createApprovalMapping(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async importApproval(ctx, { payload, params }) {
      try {
        const { data } = await sshcp.importApproval(payload, params);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },

    // Form Request
    async getActivities({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getActivities(params);
        if (params.paginate) {
          const {
            result,
            pagination,
            total_data: totalData
          } = data.data.findActivities;
          commit('set', {
            activities: result,
            pagination,
            totalData
          });
        } else {
          const activities = data.data.findActivities;
          commit('set', {
            activities,
            totalData: activities.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getDistrictManager({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getDistrictManager(params);
        commit('set', { data });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getIObyPO({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getIObyPO(params);
        commit('set', { data });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getGLAccountbyIO({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getGLAccountbyIO(params);
        commit('set', { data });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getFormRequests({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getFormRequests(params);
        const formRequests = data.data;
        commit('set', {
          formRequests
        });
        return data;
      } catch (e) {
        return [];
      }
    },
    async getFormRequestDetail({ commit }, id) {
      commit('set', {
        formRequest: null
      });
      try {
        const { data } = await sshcp.getFormRequestDetail(id);
        const formRequest = data.data.formRequest;
        commit('set', {
          formRequest
        });
        return data;
      } catch (e) {
        return null;
      }
    },
    async saveAsDraft(ctx, payload) {
      try {
        const { data } = await sshcp.saveAsDraft(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async updateFormRequest(ctx, payload) {
      try {
        const { data } = await sshcp.updateFormRequest(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async submitFormRequest(ctx, payload) {
      try {
        const { data } = await sshcp.submitFormRequest(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async getProgressTracking({ commit }, id) {
      commit('set', {
        progressTracking: null
      });
      try {
        const { data } = await sshcp.getProgressTracking(id);
        const progressTracking = data.data.result;
        commit('set', {
          progressTracking
        });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async uploadSuppDocs({ commit }, payload) {
      try {
        const { data } = await sshcp.uploadSuppDocs(payload);
        const uploadSuppDocs = data.data;
        commit('set', {
          uploadSuppDocs
        });
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async getSummaryDetail({ commit }, id) {
      commit('set', {
        formRequest: null
      });
      try {
        const { data } = await sshcp.getSummaryDetail(id);
        return data;
      } catch (e) {
        return e;
      }
    },
    async downloadSuppDocs({ commit }, id) {
      commit('set', {
        formRequest: null
      });
      try {
        const { data } = await sshcp.downloadSuppDocs(id);
        return data;
      } catch (e) {
        return e;
      }
    },
    async approveRequest(ctx, payload) {
      try {
        const { data } = await sshcp.approveRequest(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async rejectRequest(ctx, payload) {
      try {
        const { data } = await sshcp.rejectRequest(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async getTotalBudgetPO({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getTotalBudgetPO(params);
        const totalBudget = data.data;
        commit('set', {
          totalBudget
        });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getRequestLogs({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getRequestLogs(params);
        const requestLogs = data.data;
        commit('set', {
          requestLogs
        });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },

    // RE ROUTE REQUEST
    async getUserApprover({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getUserApprover(params);
        commit('set', { data });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getRequestApproval({ commit }, id) {
      try {
        const { data } = await sshcp.getRequestApproval(id);
        commit('set', { data });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async requestReRoute(ctx, payload) {
      try {
        const { data } = await sshcp.requestReRoute(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },

    // AFTER B-RIGHT
    async submitPrevalNumber(ctx, payload) {
      try {
        const { data } = await sshcp.submitPrevalNumber(payload);

        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async detailPrevalNumber({ commit }, id) {
      try {
        const { data } = await sshcp.detailPrevalNumber(id);
        commit('set', { data });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async approvePreval(ctx, payload) {
      try {
        const { data } = await sshcp.approvePreval(payload);

        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async rejectPreval(ctx, payload) {
      try {
        const { data } = await sshcp.rejectPreval(payload);

        return data;
      } catch (err) {
        return err.response.data;
      }
    },

    // MY PENDING APPROVAL
    async getApprovalBeforeBright({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getApprovalBeforeBright(params);
        commit('set', { data });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async getApprovalAfterBright({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getApprovalAfterBright(params);
        commit('set', { data });
        return data;
      } catch (e) {
        return e.response.data;
      }
    },

    // DASHBOARD
    async getDashboard({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getDashboard(params);
        const dashboard = data.data;
        commit('set', {
          dashboard
        });
        return data;
      } catch (e) {
        return [];
      }
    },
    async getBudgetChart({ commit }, params = {}) {
      try {
        const { data } = await sshcp.getBudgetChart(params);
        const budgetChart = data.data;
        commit('set', {
          budgetChart
        });
        return data;
      } catch (e) {
        return [];
      }
    }
  },
  getters: {
    formRequests: state => state.formRequests,
    formRequest: state => state.formRequest,
    progressTracking: state => state.progressTracking,
    regionsMapping: state => state.regionsMapping,
    districtByRegion: state => state.districtByRegion,
    districts: state => state.districts,
    vendors: state => state.vendors,
    filter: state => state.filter,
    activities: state => state.activities
  }
};
